/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Typography from '@mui/material/Typography';

const Affiliates = () => {
  return (
    <>
      <Typography gutterBottom variant="body1">
        Our site may contain affiliate links, which includes links placed by
        TravelFeed as well as links placed by authors. This includes links to
        GetYourGuide, Guruwalk and many other affiliate programs. The booking
        links on our destination travel guides are affiliate links.
      </Typography>
      <Typography gutterBottom variant="body1">
        This means that if you click on a product or service link and make a
        purchase, we (or the author) may earn a commission. This commission
        comes at no additional cost to you and helps support the maintenance and
        growth of this site (the author's blog).
      </Typography>
      <Typography gutterBottom variant="body1">
        Please be aware that the decision to purchase any recommended product or
        service is entirely up to you, and we encourage you to do your own
        research before making any purchases. Your support through affiliate
        links is greatly appreciated and allows us to continue providing
        valuable content and resources for fellow travelers.
      </Typography>
      <Typography gutterBottom variant="body1">
        Thank you for your support!
      </Typography>
    </>
  );
};

export default Affiliates;
